rdefine('app/products/properties/timebox',['backbone','text!products/prop/worktime.html'],function(Backbone,template) {
    
    var bindings = {};
    var bkeys=['m_t','tu_t','we_t','th_t','fr_t','sa_t','su_t'];
    var keys=[];
    _.each(bkeys,function(key){
        for(var i=1;i<5;i++) {
            keys.push(key+i);
        }
    }.bind(this));
    var ds={};
    console.log(keys);
    _.each(keys, function(key) {
        ds[key] = '';
        bindings['[data-in="'+key+'"]'] = {
            toggle:{
                data:['pmodel.'+key],
                processor:function(a) {
                    return ( a && a.length)?true:false;
                }
            }
        };
        bindings['input.'+key]={
            value:{
                events:'change dp.change',
                data:'pmodel.'+key
            }
        };
    });

    console.log(bindings);
    
    return Backbone.Ribs.View.extend({
        bindings:bindings,
        field:'',
        events:{
            "click .cross-button":"clearValue"
        },
        pmodel:null,
        initialize:function(options) {
            this.$el.append(Template7.compile(template)());
            this.$el.find("[data-in]").hide();
            this.cform = options.cform;
            this.field = "property_"+this.model.get("id");
            var ov=this.cform.get(this.field);
            this.pmodel = new Backbone.Ribs.Model(ov?_.extend(ds,_.clone(ov)):ds);
            this.pmodel.on("change",function(){
                this.cform.set(this.field,this.pmodel.attributes);
                this.cform.trigger('change');
            }.bind(this));

            _.defer(function(self){
                self.$el.find('.time-picker').datetimepicker({
                    format: 'HH:mm'
                });
            },this);

        },
        clearValue:function(e){
            this.pmodel.set($(e.currentTarget).attr("data-in"),"");
            return false;
        }
    });
});